module.exports = __webpack_public_path__ + "static/img/wxLogo.e8575f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dinnerMana/wxLogo.png
// module id = n45G
// module chunks = 1